import { graphql, useStaticQuery } from "gatsby";

export const useCheckInQuery = (keyword) => {
  const { allStrapiCheckIn } = useStaticQuery(graphql`
    query CheckInQuery {
      allStrapiCheckIn {
        nodes {
          keyword

          banner_section {
            desktop_bg {
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: CONSTRAINED
                    width: 1600
                    quality: 70
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                  )
                }
              }
            }

            mobile_bg {
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: CONSTRAINED
                    width: 768
                    quality: 70
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                  )
                }
              }
            }

            heading
            text_color

            description {
              data {
                description
              }
            }
          }

          navigation_tabs {
            active_tab_color
            bg_color
            href
            tab_id
            tab_color
            tab_name
          }

          before_you_reach {
            heading
            heading_color

            cards {
              card_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 400
                      quality: 60
                      placeholder: BLURRED
                      formats: [AUTO, WEBP]
                    )
                  }
                }
              }

              heading

              description {
                data {
                  description
                }
              }

              heading_color
            }
          }

          check_in_steps {
            heading

            description {
              data {
                description
              }
            }

            cards {
              card_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 350
                      quality: 60
                      placeholder: BLURRED
                      formats: [AUTO, WEBP]
                    )
                  }
                }
              }

              heading
              card_bg_color
              heading_color

              description {
                data {
                  description
                }
              }
            }
          }

          tips_section {
            heading

            description {
              data {
                description
              }
            }

            cards {
              card_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 816
                      quality: 80
                      placeholder: BLURRED
                      formats: [AUTO, WEBP]
                    )
                  }
                }
              }

              description {
                data {
                  description
                }
              }
            }
          }

          support_section {
            hero_image {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 800
                    quality: 65
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                  )
                }
              }
            }

            hero_image_mobile {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 600
                    quality: 65
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                  )
                }
              }
            }

            helpline_buttons {
              heading
              heading_color

              button {
                bg_color
                href
                label
                label_color

                icon {
                  alternativeText
                  url
                }
              }
            }
          }
        }
      }
    }
  `);

  return allStrapiCheckIn?.nodes?.find(
    (item) => item.keyword === keyword
  );
};